import { memo } from 'react';

type ClickToPayLogoNoBrandProps = {
  width?: number;
  height?: number;
};

const ClickToPayLogoNoBrand = ({
  width = 19,
  height = 14,
}: ClickToPayLogoNoBrandProps) => {
  return (
    <svg
      width={width.toString()}
      height={height.toString()}
      viewBox="7.99 0 16.22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2085 6.10213L20.2928 1.55113C20.2102 1.41621 20.0609 1.32611 19.8905 1.32611C19.6307 1.32611 19.42 1.53561 19.42 1.79416C19.42 1.93038 19.4785 2.05302 19.572 2.13858L23.1192 6.41595L19.6114 10.6121H18.096L21.4111 6.77533C21.4132 6.77296 21.4151 6.77059 21.4172 6.76823C21.5095 6.66727 21.5513 6.54956 21.5491 6.43328C21.5513 6.31706 21.5102 6.19909 21.4179 6.09814C21.4158 6.09577 21.4132 6.09359 21.4111 6.09129L17.4524 1.55854L17.4497 1.55537C17.3678 1.41808 17.2172 1.32611 17.0451 1.32611H14.2649C14.005 1.32611 13.7943 1.53561 13.7943 1.79416C13.7943 1.87262 13.8051 1.95419 13.8482 2.01158L17.5326 6.45066L14.3924 10.1979C14.3737 10.2165 14.1031 10.6 13.6274 10.6H9.87708C9.36704 10.6 8.94409 10.2041 8.94409 9.67826V3.1825C8.94409 2.72473 9.36704 2.25455 9.8886 2.25455H12.2218C12.4968 2.25455 12.6923 2.06773 12.6923 1.79416C12.6923 1.52059 12.4968 1.31726 12.2218 1.31726L9.86574 1.32654C8.74962 1.32654 7.99982 2.24215 7.99982 3.17297V9.67826C7.99982 10.6805 8.88814 11.5342 9.86574 11.5342H13.615C13.8041 11.5342 13.977 11.5066 14.1328 11.4625C14.155 11.4562 14.177 11.4495 14.1984 11.4426C14.7154 11.276 15.0274 10.9336 15.0878 10.8611L18.6217 6.76442C18.7889 6.57579 18.8111 6.30223 18.6245 6.09814C18.6224 6.09577 18.6198 6.09359 18.6177 6.09129L15.2749 2.25455H16.818L20.3114 6.43334L16.6353 10.844C16.6353 10.844 16.6364 10.8491 16.6416 10.855C16.6072 10.92 16.5877 10.9939 16.5877 11.0725C16.5877 11.3309 16.7984 11.5405 17.0582 11.5405H19.8384C20.0106 11.5405 20.1611 11.4484 20.2431 11.3112L20.2458 11.3081L24.2044 6.77533C24.2065 6.77296 24.2085 6.77059 24.2105 6.76823C24.3971 6.56408 24.3756 6.29076 24.2085 6.10213Z"
        fill="black"
      />
    </svg>
  );
};

export const ClickToPayLogoNoBrandIllustration = memo(ClickToPayLogoNoBrand);
